module.exports = __webpack_public_path__ + "Roboto-BlackItalic.4b7407c6740b8294d97a.eot";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/roboto-fontface/fonts/roboto/Roboto-BlackItalic.eot
// module id = ../../../../roboto-fontface/fonts/roboto/Roboto-BlackItalic.eot
// module chunks = styles